import api from '@pray/shared/utils/api';

function normalizedInstruction(value) {
  return value?.trim() || null;
}

export async function saveWorkflowAISettings({ artistId, autoScheduleAnnouncements, styleGuide, stepInstructions }) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/settings/workflow-ai`;
  const response = await api.executePutRequest(url, {
    auto_schedule_announcements: autoScheduleAnnouncements,
    style_guide: normalizedInstruction(styleGuide),
    step_instructions: {
      announcement: normalizedInstruction(stepInstructions?.announcement),
      email: normalizedInstruction(stepInstructions?.email),
      summary: normalizedInstruction(stepInstructions?.summary),
    },
  });

  return response.data.data;
}
